export default __webpack_public_path__ + "static/media/banner.a3e7080e.png";